/**
 * Bundle Builder
 * Page: Build Your Own Bundle (template: page.bundle-builder-2)
 * Widget: 01.21.26 - Bundle Builder (Rebuy ID: 267416)
 *
 * Defaults the purchase option to Subscribe & Save on load.
 */

(function () {
  // Rebuy widget DOM ID — update if the widget ID changes
  const WIDGET_ID = 'rebuy-widget-267416';

  function init() {
    // Default to Subscribe & Save on load
    const subscribeRadio = document.querySelector(
      `#${WIDGET_ID} input.rebuy-bundle-builder__action-box-radio[value="subscription"]`
    );
    if (subscribeRadio && !subscribeRadio.checked) {
      setTimeout(() => subscribeRadio.click(), 100);
    }
  }

  // Rebuy renders asynchronously — poll until the widget appears
  const interval = setInterval(() => {
    if (document.getElementById(WIDGET_ID)) {
      clearInterval(interval);
      init();
    }
  }, 300);
})();
